export enum CallingRoutesSteps {
  root = 'calling',
  view = 'view',
  enableVoiceIntegrity = 'enable-voice-integrity',
  companyInfo = 'company-info',
  enableStirShaken = 'enable-stir-shaken',
  enableCnamCallerId = 'enable-cnam-caller-id',
  configure = 'configure',

  editCnamNumbers = 'edit-cnam-numbers',
}
